export const environment = {
  production: true,
  //DESARROLLO
  // apiScar: 'http://localhost:56909/',
  // apimailing: 'http://10.6.95.45:190/'
  // CALIDAD
  // apiScar: 'https://pruebas-apisiicart.aguapuebla.mx/',
  // apimailing: 'https://pruebas-apimailing.aguapuebla.mx/',
  // servRESTGIS: 'https://arcgisouc.aguapuebla.mx/arcgis/rest/services/Calidad/'
  // PRODUCCION
  apiScar: 'http://apisiicart.aguapuebla.mx/',
  apimailing: 'http://apimailing.aguapuebla.mx/',
   servRESTGIS: 'https://arcgisouc.aguapuebla.mx/arcgis/rest/services/Produccion/'
};
